import PreviewPaneStore from './schema/PreviewPaneStore';
import { createStore } from 'satcheljs';

const initialPreviewPaneStore: PreviewPaneStore = {
    viewState: null, // defaults to null
};

export const getStore = createStore<PreviewPaneStore>('previewpane', initialPreviewPaneStore);
export default getStore();
